<template>
    <div id="listJournal">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Journal Entries</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="btn-groups text-right">
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
                            <i class="fp-export"></i> Export
                        </a>
                        <!-- <template v-if="canPostJournal">
                            <a v-if="postJournal" href="javascript:void(0)" class="btn btn-secondary" v-on:click="postJournals()">
                                Post Journal
                            </a>
                        </template> -->
                        <router-link v-if="canAddJournal" class="btn btn-primary" v-bind:to="{name: 'JournalCreate'}"> <i class="fp-add"> </i> Add</router-link>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content journal-list">
                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <data-table-filter-config :moduleName="'journalsList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="data-table bg-white">
                                  <custom-pagination
                                          :page-changed="onPageChange"
                                          :per-page-changed="onPerPageChange" :moduleName="'journalsList'" :position="'top'">
                                  </custom-pagination>

                                  <vue-good-table
                                      ref="listJournalsTable"
                                      mode="remote"
                                      title="Journals"
                                      @on-row-click="onRowClick"
                                      @on-page-change="onPageChange"
                                      @on-selected-rows-change="selectionChanged"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      @on-select-all="onSelectAll"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :paginate="true"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                      enabled: journal_value,
                                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                      selectionInfoClass: 'custom-class',
                                      selectionText: 'rows selected',
                                      clearSelectionText: 'clear',
                                      }"
                                      :search-options="{
                                      enabled: false,
                                      }">

                                      <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                          <div :key="key">
                                              <div v-if="props.column.field == 'action'">
                                                      <!-- <router-link v-if="canUpdateJournal && props.row.status == 'Draft'" title="Edit Journal" class="fp-edit" v-bind:to="{name: 'JournalEdit',params:{id:props.row.id}}"></router-link> -->
                                                      <router-link v-if="canUpdateJournal && (props.row.is_editable != undefined && props.row.is_editable == 1)" title="Edit Journal" class="fp-edit" v-bind:to="{name: 'JournalEdit',params:{id:props.row.journal_number}}"></router-link>
                                              </div>
                                              <div v-else-if="props.column.field == 'reference'">
                                                  <span v-fp-html="props.formattedRow[props.column.field]"></span>
                                              </div>
                                              <div v-else-if="props.column.field == 'journal_number'">
                                                  <router-link  title="View Journal" class="color-blue" v-bind:to="{name: 'JournalView',params:{id:props.row.journal_number}}">{{props.row.journal_number}}</router-link>
                                              </div>
                                              <div v-else-if="props.column.field == 'journal_amount'">
                                                  {{ amountFormat(props.row.journal_amount) }}
                                              </div>
                                              <div v-else>
                                                  {{props.formattedRow[props.column.field]}}
                                              </div>
                                          </div>
                                      </template>
                                      <div slot="selected-row-actions">
                                        <button v-if="canDeleteJournal" id="deleteJournalBtn" v-on:click.prevent="deleteJournal" class="btn btn-danger">Delete</button>
                                      </div>
                                  </vue-good-table>
                                  <custom-pagination
                                          :page-changed="onPageChange"
                                          :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                        <div class="modal fade sub-system-journal-message-modal" id="sub-system-journal-message-modal" ref="subSystemJournalMessageModal" data-backdrop="static" data-keyboard="false" aria-labelledby="subSystemJournalMessageModal" aria-hidden="true">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Message</h5>
                                        <button type="button" class="close" id="btnModalJournalSubClose" v-on:click="hideSubSystemMessageModal()">&times;</button>
                                    </div>
                                    <div class="modal-body">
                                        <p class="color-red" v-show="subSystemClosedMsgError">Subsystem O/E DIRECT ENTRY has been closed.</p>
                                        <p v-show="subSystemClosedMsgError">Following journal(s) cannot be deleted : </p>
                                        <template v-if="subSystemClosedMsgArr.length">
                                            <template v-for="(inv,key) in subSystemClosedMsgArr">
                                                <a :key="'ijournal' + key" v-if="key > 0">&nbsp;&nbsp; | &nbsp;&nbsp;</a><span :key="'jjournal' + key"> {{inv}}</span>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';


import EventBus from ".././event-bus";


import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
    name: "JournalList",
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Journal List | " +process.env.COPYRIGHT_NAME
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
        firstLoad : 0,
        userColumns:[],
        columns: [
            {
                label: 'Actions',
                field: 'action',
                html: true,
                sortable: false,
            },
            {
                label: '#Journal',
                field: 'journal_number',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Module", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Description',
                field: 'journal_desc',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Description", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            // {
            //     label: 'Financial Period',
            //     field: 'financial_period',
            //     filterable: true,
            //     fpFieldType:"option",
            //     hidden:false,
            //     filterOptions: {
            //         enabled: false, // enable filter for this column
            //         placeholder: "Financial Period", // placeholder for filter input
            //         filterValue: '', // initial populated value for this filter
            //         trigger: "enter" //only trigger on enter not on keyup
            //     }
            // },
            {
                label: 'Month',
                field: 'month',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Month", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Year',
                field: 'year',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Month", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Post Date',
                field: 'post_date',
                filterable: true,
                fpFieldType:"date",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Date", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: "Amount",
                field: "journal_amount",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Amount", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: "Created By",
                field: "created_by",
                fpFieldType:"text",
                hidden:false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Created By", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
        ],
        rows: [],
        totalRecords: 0,
        permissions:[],
        loading:false,
        cantAccessPage:"",
        journal_value:true,
        reqeustSent:0,
        postJournal:false,
        canPostJournal:false,
        canAddJournal:false,
        canUpdateJournal:false,
        action:'list',
        pageKey:"_journal_list_",
        subSystemClosedMsgError:false,
        subSystemClosedMsgArr:[],
        batchProcess:0,
        batchNum:"",
        canDeleteJournal:false
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'list_journal') {
                    self.cantAccessPage = true;
                }
                if(permissions.name == 'post_journal') {
                    self.canPostJournal = true;
                }
                if(permissions.name == 'add_journal') {
                    self.canAddJournal = true;
                    self.canUpdateJournal = true;
                }
                if(permissions.name == 'delete_journal') {
                    self.canDeleteJournal = true;
                }
            });
        }
    },
    created: function() {
        this.serverParams.sort = {field:"id",type:"asc"};
    },
    mounted: function () {

        this.getPermissions();

    },
    methods: {
        cancelAll: function (cancelAll) {
            this.$refs.listJournalsTable.unselectAllInternal();
        },
        selectionChanged(param) {
            var self = this;
            var rowData = self.$refs['listJournalsTable'].selectedRows;
            if(rowData.length > 0){
                self.postJournal = true;
            }else{
                self.postJournal = false;
            }

            self.serverParams.selectedAll = false;
            if(param.selectedRows.length == 100) {
              EventBus.$emit('clear-selection', false);
            } else {
              EventBus.$emit('clear-all-flags', false);
            }
        },
        exportCheck: function() {
            var self = this;
            var count = 0;
            var actionFlag = "";
            var data = this.$refs['listJournalsTable'].selectedRows;
            count = data.length;

            if(this.serverParams.selectedAll == true){
                actionFlag = "";
            }else if(count != 0 && count <= 100){
                actionFlag = "export";
            }

            this.exportReports(actionFlag);
        },
        loadList() {
            //remove row of details if any open
            var self = this;
            $('table tr.invoiceDetails').remove();
            var rowData = self.$refs['listJournalsTable'].selectedRows;
            var found = false;
            var journalIdArr = [];
            var use = [];

            for(var i = 0;i < rowData.length; i++){
                if (rowData[i].status == 'Posted') {
                    found = true;
                }else{
                    journalIdArr.push(rowData[i].id);
                }
                use.push(rowData[i].journal_number);
            }


            self.loading = true;
            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action:self.action,
                all:self.serverParams.selectedAll,
                id:journalIdArr,
                selectedRows:use,
            };
            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/journal/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    // console.log(data);
                    if (data.status == "success") {
                        if ( self.action == "export" ||  self.action == "export_queue") {
                            if ( data.code == "201" ) {
                                alert(data.message);
                            } else {
                                if ( self.action == "export" ) {
                                    self.excel = data.content.web;
                                    var save = document.createElement("a");
                                    save.href = self.excel;
                                    save.download = data.content.web;
                                    save.target = "_blank";

                                    document.body.appendChild(save);
                                    save.click();
                                    document.body.removeChild(save);

                                } else {

                                    self.batchProcess = 1;
                                    self.batchNum = data.content;
                                }
                            }
                            self.action = "list";
                            self.loadList();

                        }else if (self.action == 'post'){
                            if (data.content.sub_system.length > 0) {
                                //Show Message if Sub System closed for Journals Post
                                self.subSystemClosedMsgError = true;
                                self.subSystemClosedMsgArr = data.content.sub_system;
                                $("#sub-system-journal-message-modal").modal("show");
                            }else{
                                self.$swal('','Journals Posted','success');
                            }
                            self.action = 'list';
                            self.loadList();
                        }else if (self.action == "delete") {
                            if (data.content.sub_system.length > 0) {
                                //Show Message if Sub System closed for Journals Delete
                                self.subSystemClosedMsgError = true;
                                self.subSystemClosedMsgArr = data.content.sub_system;
                                $("#sub-system-journal-message-modal").modal("show");
                            }else{
                                var msg = "";
                                msg = data.content.count+" records have been deleted";
                                self.$swal('',msg,data.status);
                            }
                            self.action = "list";
                            EventBus.$emit('clear-all-flags', false);
                            self.loadList();
                            return;
                        }else{
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'journal-list')
                }
            });
        },
        onRowClick(params) {

            var self = this;


            if ( $(params.event.target).hasClass("vgt-checkbox-col") || $(params.event.target).hasClass("glyphicon glyphicon-eye-open")) {
                return;
            }

            if ( self.reqeustSent == 1 ) {
                return;
            }

            //if data already available than remove it
            if ( $(params.event.target.closest('.clickable').nextSibling).hasClass("invoiceDetails")) {
                $(params.event.target.closest('.clickable').nextSibling).remove();
                return;
            }

            //generate html
            var html = '<tr class="invoiceDetails"><td colspan="8"><table aria-describedby="table" class="table">';
                html += '<tr><th>GL Account</th><th>Account Type</th><th>Description</th><th>Debit</th><th>Credit</th><th>Amount</th></tr>';

            var fields = {
                journal_id:params.row.journal_number,
            };
            self.reqeustSent = 1;
            self.loading = true;

            $.ajax({
                url: process.env.ROOT_API + "/journal/items",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {

                    self.reqeustSent = 0;
                    self.loading = false;
                    if ( data.code == 200 ) {

                        //check data records
                        if ( data.content.length > 0 ) {

                            for ( var j=0; j<data.content.length; j++ ) {
                                html += '<tr><td>'+data.content[j].account_description+'</td><td>'+data.content[j].account_type+'</td><td>'+ data.content[j].description +'</td><td>'+data.content[j].debit+'</td><td>'+data.content[j].credit+'</td><td>'+data.content[j].journal_amount+'</td></tr>';
                            }

                        } else {
                            html += '<tr><td colspan="4">No record found.</td></tr>';
                        }

                        html += '</table></td></tr>';
                        $(html).insertAfter(params.event.target.closest('.clickable'));

                    }
                },
                error: function (jqXHR, exception) {

                    self.reqeustSent = 0;

                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'journal-item')
                }
            });
        },
        postJournals() {
            var self = this;
            var rowData = self.$refs['listJournalsTable'].selectedRows;
            var found = false;
            var journalIdArr = [];

            for(var i = 0;i < rowData.length; i++){
                if (rowData[i].status == 'Posted') {
                    found = true;
                }else{
                    journalIdArr.push(rowData[i].id);
                }
            }

            if ( found ) {
                self.$swal('',"Journals with status Draft only be Posted.",'info');
                return;
            }

            self.action = 'post';
            self.loadList();

            // self.loading = true;

            // $.ajax({
            //     url: process.env.ROOT_API + "/post/journals",
            //     type: "POST",
            //     data: {arr:journalIdArr},
            //     headers: {
            //         "Accept": "application/json",
            //         "Authorization": "Bearer " + localStorage.getItem("tkn"),
            //         "Access-Control-Allow-Headers":
            //             "Origin, Content-Type, Authorization,X-Requested-With",
            //         "Cache-Control": "no-cache"
            //     },
            //     dataType: "json",
            //     success: function (data) {

            //         self.loading = false;
            //         if(data.code == 201){

            //         }
            //         if (data.status == "success") {
            //             self.$swal('','Journals Posted','success');
            //             self.loadList();
            //         }
            //     },
            //     error: function (jqXHR, exception) {

            //         self.loading = false;
            //         self.generateStatusCodeMessage(jqXHR,true,'post-journal')
            //     }
            // });
        },
        hideSubSystemMessageModal() {
            var self = this;
            self.subSystemClosedMsgError = false;
            self.subSystemClosedMsgArr = [];
            $("#sub-system-journal-message-modal").modal("hide");
        },
        deleteJournal() {
            var self = this;
            self.$swal({
                title: 'Are you sure that you want to delete this Journal Entry?',
                type: 'info',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: false,
                showLoaderOnConfirm: true
            }).then((result) => {
                if (result.value) {
                    self.action = "delete";
                    self.loadList();
                } else {
                }
            });
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/accounting/JournalList.vue